export const APP_CONFIG = {
  ORGANIZATION_NAME: 'Casa do Pandeiro',
  ADDRESS: 'TRAVESSA DO OUVIDOR, 36 CENTRO/RJ',
  CONTACT_EMAIL: 'contato@casadopandeiro.com',
  WEBSITE_URL: 'https://casadopandeiro.com'
} as const; 